<template>
	<div class="banner_wrapper" :style="bannerWrapperStyle">
		<ins class="kakao_ad_area" :data-ad-unit="bannerAdUnitId" :data-ad-onfail="failCallbackName" ref="kakaoAdAreaEl"/>
	</div>
</template>

<script>
export default {
	props: ['bannerAdUnitId', 'index'],
	data() {
		return {
			hidden: false,
			failCallbackName: `onBannerLoadFail${this.index}`,
		};
	},
	computed: {
		bannerWrapperMinHeight() {
			const BANNER_MAX_HEIGHT = 384;
			const TEXT_AREA_HEIGHT = 100;
			const minHeight = Math.ceil(window.innerWidth / 2) + TEXT_AREA_HEIGHT;

			return Math.min(minHeight, BANNER_MAX_HEIGHT);
		},
		bannerWrapperStyle() {
			return {
				minHeight: `${this.bannerWrapperMinHeight}px`,
				display: this.hidden ? 'none' : 'block',
			};
		}
	},
	mounted() {
		window[this.failCallbackName] = () => {
			this.hidden = true;
		};

		adfit.render(this.$refs.kakaoAdAreaEl);
	}
}
</script>
